import React from 'react'
import { string, func } from 'prop-types'
import classnames from 'classnames/bind'

import styles from './index.module.css'

const cx = classnames.bind(styles)

export default function DontKnowButton(props) {
  const { status, handleDontKnowClick } = props
  const handleClick = () => {
    if (status === 'initial') {
      handleDontKnowClick()
    }
  }

  return (
    <div
      className={cx('button', {
        hide: status === 'hide'
      })}
      onClick={handleClick}
    >
      <span>不认识</span>
    </div>
  )
}

DontKnowButton.propTypes = {
  status: string,
  handleDontKnowClick: func
}
